import React from 'react';
import './ProfileWidget.scss';

function ProfileDemoTab({ employeeDetails, passportDoc, visaDoc }) {
  return (
    <div className="profile-widget-tab">
      <div className="d-flex flex-row justify-content-between">
        <span className="profile-widget-label">Date of Birth</span>
        <span className="profile-widget-value fw-semibold">
          {employeeDetails?.[0]?.DateofBirth}
        </span>
      </div>
      <div className="d-flex flex-row justify-content-between">
        <span className="profile-widget-label">Nationality</span>
        <span className="profile-widget-value fw-semibold">
          {employeeDetails?.[0]?.Nationality}
        </span>
      </div>
      <div className="d-flex flex-row justify-content-between">
        <span className="profile-widget-label">Passport No.</span>
        <span className="profile-widget-value fw-semibold">
          {passportDoc?.['Doc.No'] || 'N/A'}
        </span>
      </div>
      <div className="d-flex flex-row justify-content-between">
        <span className="profile-widget-label">Passport Expiry</span>
        <span className="profile-widget-value fw-semibold">
          {passportDoc?.ExpiryDate || 'N/A'}
        </span>
      </div>
      <div className="d-flex flex-row justify-content-between">
        <span className="profile-widget-label">Visa No.</span>
        <span className="profile-widget-value fw-semibold">
          {visaDoc?.['Doc.No'] || 'N/A'}
        </span>
      </div>
      <div className="d-flex flex-row justify-content-between">
        <span className="profile-widget-label">Visa Expiry</span>
        <span className="profile-widget-value fw-semibold">
          {visaDoc?.ExpiryDate || 'N/A'}
        </span>
      </div>
    </div>
  );
}

export default ProfileDemoTab;
